import { useTranslation } from 'react-i18next';
import { useScrollAnimation } from '@/hooks/useScrollAnimation';
import { Check, X } from 'lucide-react';

const ComparisonSection = () => {
  const { t } = useTranslation('homepage');
  const { ref, isVisible } = useScrollAnimation();

  const features = [
    'zeroContract',
    'verifiedPractitioners',
    'healingFramework',
    'domainFiltering',
    'modalityDatabase',
    'aiAssessment',
    'progressTracking',
  ];

  return (
    <section
      ref={ref}
      className={`py-16 md:py-24 bg-gradient-to-b from-amber-50/50 to-background transition-all duration-700 ${
        isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-10'
      }`}
    >
      <div className="container mx-auto px-4">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground">
            <span className="text-amber-600">Resonow</span> {t('comparisonTitle')}
          </h2>
        </div>

        {/* Comparison Table */}
        <div className="max-w-3xl mx-auto">
          <div className="rounded-xl overflow-hidden shadow-lg border border-border">
            {/* Table Header */}
            <div className="grid grid-cols-[1fr,100px,100px] md:grid-cols-[1fr,120px,120px]">
              <div className="bg-muted/50 p-4" />
              <div className="bg-amber-600 p-4 text-center">
                <span className="text-white font-bold text-sm md:text-base">
                  {t('comparisonResonow')}
                </span>
              </div>
              <div className="bg-gray-200 dark:bg-gray-700 p-4 text-center">
                <span className="text-gray-700 dark:text-gray-300 font-bold text-sm md:text-base">
                  {t('comparisonOthers')}
                </span>
              </div>
            </div>

            {/* Table Body */}
            {features.map((feature, index) => (
              <div
                key={feature}
                className={`grid grid-cols-[1fr,100px,100px] md:grid-cols-[1fr,120px,120px] ${
                  index % 2 === 0 ? 'bg-background' : 'bg-amber-50/50 dark:bg-amber-950/20'
                }`}
              >
                <div className="p-4 flex items-center border-t border-border">
                  <span className="text-sm md:text-base text-foreground">
                    {t(`comparisonFeatures.${feature}`)}
                  </span>
                </div>
                <div className="p-4 flex items-center justify-center border-t border-border bg-amber-50/30 dark:bg-amber-950/10">
                  <div className="w-7 h-7 rounded-full bg-green-500 flex items-center justify-center">
                    <Check className="w-4 h-4 text-white" strokeWidth={3} />
                  </div>
                </div>
                <div className="p-4 flex items-center justify-center border-t border-border">
                  <X className="w-6 h-6 text-red-400" strokeWidth={2.5} />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default ComparisonSection;
